import { gql } from '@apollo/client';

/**
 * Deliberately lean: these queries return every worker available for a job, so a
 * large tenant can push the response past Lambda's 6MB payload limit. Only select
 * what the worker pickers and assignment rate inputs actually render.
 */
export const AVAILABLE_WORKER_FIELDS = gql`
  fragment AvailableWorkerFields on User {
    id
    firstName
    lastName
    email
    phoneNumber
    profilePictureUrl
    status
    classificationLevels {
      id
      name
      classificationId
      minimums {
        countryHash
        minimum
      }
    }
  }
`;

export const AVAILABLE_WORKERS_FOR_JOB_QUERY = gql`
  query GetUsersAvailableForJob($jobId: String!) {
    getUsersAvailableForJob(jobId: $jobId) {
      ...AvailableWorkerFields
    }
  }
  ${AVAILABLE_WORKER_FIELDS}
`;

export const AVAILABLE_WORKERS_FOR_JOB_CRITERIA_QUERY = gql`
  query GetUsersAvailableForJobCriteria(
    $classificationId: String!
    $clientId: String!
    $startDate: String!
    $endDate: String!
    $lat: Float
    $lng: Float
  ) {
    getUsersAvailableForJobCriteria(
      classificationId: $classificationId
      clientId: $clientId
      startDate: $startDate
      endDate: $endDate
      lat: $lat
      lng: $lng
    ) {
      ...AvailableWorkerFields
    }
  }
  ${AVAILABLE_WORKER_FIELDS}
`;
